import React from 'react';
import { IOrderTagData } from 'types/order/tags/IOrderTagData';
import { ButtonTW } from '../../../../tailwindComponents/buttonTW/ButtonTW';
import { Form, Formik } from 'formik';
import { useUpdateOrderTagMutation } from '../../../../API/order/tags/OrderTagApi';
import { IUpdateOrderTagRequest } from '../../../../types/order/tags/ICreateOrderTagRequest';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';
import { TextFieldTW } from '../../../../tailwindComponents/textInputTW/TextFieldTW';
import { ErrorMessageTW } from '../../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { associateOrderTagScheme } from '../../../../validation/order/OrderTagValidators';
import { IHasTestData } from '../../../../ui-toolkit/test-utilities/IHasTestData';
import { mergeTests } from '../../../../ui-toolkit/test-utilities/mergeTests';

interface UpdateOrderTagFormProps extends IHasTestData {
  orderTag: IOrderTagData;
  setEditTag: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UpdateOrderTagForm: React.FC<UpdateOrderTagFormProps> = ({
  orderTag: { orderId, tag, value, ...rest },
  setEditTag,
}) => {
  const [updateOrderTag, { error, isLoading }] = useUpdateOrderTagMutation();

  const handleSubmit = async (values: IUpdateOrderTagRequest) => {
    const result = await updateOrderTag(values);
    if (checkForMutationSuccess(result, 'Order Tag Updated', 'Error Updating Order Tag')) {
      setEditTag(false);
    }
  };
  const initialValues = { orderId, tagId: tag.id, value: value ?? '' };
  return (
    <div
      data-test-id={mergeTests(rest['data-test-id'], 'order-tag-update-form')}
      data-test-class={mergeTests(rest['data-test-class'], 'order-tag-update-form')}
    >
      <ErrorMessageTW rtkError={error} />
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={associateOrderTagScheme}
        initialTouched={{ value: true }}
      >
        {({ isValid, dirty }) => (
          <Form>
            <TextFieldTW
              name={'value'}
              placeholder={value || 'Value'}
              data-test-id={'order-tag-update-form'}
              data-test-class={'order-tag-update-form'}
            />
            <ButtonTW
              secondary
              type={'submit'}
              className={'flex items-center'}
              disabled={!isValid || !dirty || isLoading}
              data-test-id={'order-tag-update-form'}
              data-test-class={'order-tag-update-form'}
            >
              Update
            </ButtonTW>
          </Form>
        )}
      </Formik>
    </div>
  );
};
